module.exports = __webpack_public_path__ + "img/goldregen-2020-032.e768c843.jpg";